import { ApplicationDependencyService, ApplicationGroupingService } from '@amzn/awscat-portfolio-assessment-service-client';
import { FlashContextInterface, FlashType, withFlashContext } from '@amzn/awscat-react-components';
import { Checkbox, SpaceBetween } from '@amzn/awsui-components-react';
import { useState } from 'react';
import { match, useRouteMatch } from 'react-router';
import { useIsMounted } from 'react-tidy';

import { constants } from '../../../common/Localization';
import { MatchParam } from '../../../common/types';
import ConfirmationModal from '../../common/ConfirmationModal';

type Props = FlashContextInterface & {
    onDismiss: () => void;
    loadData: () => void;
};

type TypesMap = {
    server: boolean;
    database: boolean;
    serverCommunication: boolean;
    appToApp: boolean;
};

const appDependencyService = new ApplicationDependencyService();
const applicationGroupingService = new ApplicationGroupingService();

function RemoveDependencyByType(props: Props): JSX.Element {
    const match: match<MatchParam> | null = useRouteMatch({
        path: '/portfolio/:portfolioId',
    });
    const isMounted = useIsMounted();
    const portfolioId = match?.params?.portfolioId || '';
    const [ dependencyTypesMap, setDependencyTypesMap ] = useState<TypesMap>({
        server: false,
        database: false,
        serverCommunication: false,
        appToApp: false,
    });
    const [ loading, setLoading ] = useState(false);
    const selectType = (type: keyof TypesMap, checked: boolean) => {
        setDependencyTypesMap({
            ...dependencyTypesMap,
            [type]: checked,
        });
    };
    const onConfirm = async () => {
        setLoading(true);
        try {
            await appDependencyService.removeByType({
                portfolioId,
                server: dependencyTypesMap.server,
                database: dependencyTypesMap.database,
                serverCommunication: dependencyTypesMap.serverCommunication,
                appToApp: dependencyTypesMap.appToApp,
            });
            await applicationGroupingService.createGroups(portfolioId);
            if (isMounted()) {
                props.loadData();
            }
        } catch (err) {
            if (isMounted()) {
                props.flash.alert(FlashType.error, (err as Error).message, constants.CANNOT_REMOVE_DEP_BY_TYPE);
            }
        } finally {
            if (isMounted()) {
                props.onDismiss();
                setLoading(false);
            }
        }
        
    };
    return (
        <ConfirmationModal
            visible
            header={constants.REMOVE_DEPENDENCIES_BY_TYPE}
            confirmButton={constants.CONTINUE_BUTTON_TEXT}
            confirmDisabled={Object.values(dependencyTypesMap).filter(selected => selected).length === 0}
            confirmLoading={loading}
            onConfirm={onConfirm}
            onDismiss={props.onDismiss}
        >
            <SpaceBetween size='l' direction='horizontal'>
                <Checkbox
                    data-testid='serverCheckbox'
                    checked={dependencyTypesMap.server}
                    onChange={e => selectType('server', e.detail.checked)}>
                    {constants.SERVER_RESOURCE_NAME}
                </Checkbox>
                <Checkbox
                    checked={dependencyTypesMap.database}
                    onChange={e => selectType('database', e.detail.checked)}>
                    {constants.DATABASE_RESOURCE_NAME}
                </Checkbox>
                <Checkbox
                    checked={dependencyTypesMap.serverCommunication}
                    onChange={e => selectType('serverCommunication', e.detail.checked)}>
                    {constants.SERVER_COMM_RESOURCE_NAME}
                </Checkbox>
            </SpaceBetween>
        </ConfirmationModal>
    );
}
export default withFlashContext(RemoveDependencyByType);
